import { TokenLoginResponse, UserApi } from 'mvppoker-portal-common/api'
import { useEffect } from 'react'
import toast from 'react-hot-toast'
import { JwtPayload } from 'jwt-decode'
import { useDispatch, useSelector } from 'react-redux'
import TokenUtils from 'mvppoker-portal-common/utils/TokenUtils'
import { RootState } from '../state/AppStore'
import { clearActiveUser, setActiveUser } from '../state/reducers/activeUser'
import { setGameConfig } from '../state/reducers/AppConfig'
import { makeActiveGame } from '../state/reducers/activeGame'
import { useApi } from './useApi'
import { useIsLoggedIn } from '../state/hooks/ActiveUserHooks'

const isCurrentTokenFresh = (idToken?: string) : boolean =>
{
	if (idToken){
		const payload = TokenUtils.GetTokenPayload(idToken)
		if (payload){
			const { exp } = payload as JwtPayload
			if (exp){
				const expiresAt = exp * 1000
				return Date.now() < expiresAt
			}
		}
	}
	return false
}
const canRefresh = (refreshToken?: string) : boolean =>
{
	if (refreshToken){
		// TODO: use cookies to store refresh token after login
		return true
	}
	return false
}

export const useRefreshAuthToken = () =>
{
	const isLoggedIn = useIsLoggedIn()
	const tokens = useSelector((root: RootState) => root.activeUser.tokens)
	const idToken = tokens?.idToken
	const refreshToken = tokens?.refreshToken
	const api = useApi(UserApi)
	const dispatch = useDispatch()

	const setup = (response: TokenLoginResponse) =>
	{
		dispatch(setGameConfig(response.config))
		dispatch(setActiveUser(response))
		const activeRoom = response.currentGames[0]
		const userId = response.user.id
		if (activeRoom && userId){
			dispatch(makeActiveGame({ ...activeRoom, userId }))
		}
	}
	const processError = (e: any) =>
	{
		dispatch(clearActiveUser())
		if (e.response?.status === 403) {
			if (e.response?.data.message === 'User is disabled'){
				toast.error('Your access has been disabled for 24hrs.\nPlease come again tomorrow.')
			}
		}
	}
	const loginWithToken = () : Promise<void> => 
	{
		return api
		.authUserLoginWithToken()
		.then((it) => {
			const response = {
				...it.data,
				tokens
			} as TokenLoginResponse
			setup(response)
		}).catch(processError)
	}
	const refreshTokens = (refreshToken: string) : Promise<void> => 
	{
		return api
		.authUserRefreshToken({ token: refreshToken })
		.then((it) => {
			setup(it.data)
		}).catch(processError)
	}

	useEffect(() => {
		if (isCurrentTokenFresh(idToken)){
			if (isLoggedIn){
				return
			}
			loginWithToken()
			return
		}
		if (canRefresh(refreshToken)){
			refreshTokens(refreshToken!)
			.then((it) => {
				return isLoggedIn ? Promise.resolve() : loginWithToken()
			})
		}
	}, [])
}
